import { Controller } from "stimulus"

export default class extends Controller {
  updateCost(event) {
    const selectElement = event.target;
    const selectedOption = selectElement.options[selectElement.selectedIndex];
    const optionName = selectedOption.text;
    const numbers = optionName.match(/\d+(\.\d+)?/g); // Matches one or more digits, optionally followed by a decimal and more digits

    const myInput = document.getElementById('sales_order_total_shipping');
    if (numbers){
      myInput.value = numbers[0];
    } else {
      myInput.value = 0;
    }
  }
}
